export const LOCALHOST = "localhost:3000";
export const DEV = "dev.sunhub.com";
export const QAS = "qas.sunhub.com";
export const STAGING = "staging.sunhub.com";
export const PRODUCTION = "www.sunhub.com";
